import React from 'react';
import "./UserChoice.css";
import choice1 from "../images/png/Rectangle208.png";
import choice2 from "../images/png/Rectangle209.png";
import ch1 from "../images/png/image149.png";
import ch2 from "../images/png/image152.png";
import ch3 from "../images/png/image151.png";
import cho1 from "../images/png/image153.png";
import cho2 from "../images/png/image154.png";
import cho3 from "../images/png/image156.png";


const UserChoice=()=>{
  return (
    <div>
        <div className='userchoice'>
            <div className='award'>
                <img src={choice1} alt="err"/>
                <img src={choice2} alt="err"/>
            </div>
            <div className='companeycoloum'>
                <div className='col1'>
                    <div className='logoaward'>
                        <img src={ch1} alt="err"/>
                        <h3>4.9/5</h3>   
                    </div>
                    <div className='logoaward'>
                        <img src={ch2} alt="err"/>
                        <h3>4.9/5</h3>   
                    </div>
                    <div className='logoaward'>
                        <img src={ch3} alt=""/>
                        <h3>5.0/5</h3>   
                    </div>
                    
                    
                </div>
                <div className='col1'>
                    <div className='logoaward'>
                        <img src={cho1} alt="err"/>
                        <h3>4.9/5</h3>   
                    </div>
                    <div className='logoaward'>
                        <img src={cho2} alt="err"/>
                        <h3>4.8/5</h3>   
                    </div>
                    <div className='logoaward'>
                        <img src={cho3} alt="err"/>
                        <h3>5.0/5</h3>   
                    </div>
                    
                </div>
                
            </div>
            
        </div>
    </div>
  )
}

export {UserChoice}
